import { Drawer } from "antd";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { EVENT_TYPES, QUALIFIER_TAGS } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import validation from "./validation";

const Create = ({ onSubmit, open, onClose }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.QUALIFIER);
  const CREATE = t("CREATE", { returnObjects: true });
  const FORM = t("FORM", { returnObjects: true });

  return (
    <Drawer
      open={open}
      className="drawer__area"
      title={CREATE.TITLE}
      width={500}
      onClose={onClose}
      placement="right"
    >
      <Formik
        initialValues={{
          name: null,
          description: null,
          tag: null,
          events: [],
        }}
        onSubmit={(values, { resetForm }) => {
          onSubmit(values);
          resetForm();
        }}
        validationSchema={validation(
          t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
        )}
      >
        {({ isValid, handleSubmit, values, setFieldValue, ...formProps }) => (
          <div className="grid--1">
            <Input
              label={FORM.NAME}
              placeholder={FORM.NAME}
              required
              {...bindInputProps({ name: "name", ...formProps })}
            />
            <Input
              label={FORM.DESCRIPTION}
              placeholder={FORM.DESCRIPTION}
              {...bindInputProps({ name: "description", ...formProps })}
            />
            <Select
              options={Object.entries(QUALIFIER_TAGS).map(([label, value]) => ({
                label: FORM.TAGS[label],
                value,
              }))}
              placeholder={FORM.TAG}
              label={FORM.TAG}
              {...bindInputProps({
                name: "tag",
                values,
                ...formProps,
              })}
            />
            <Select
              options={Object.entries(EVENT_TYPES).map(([key, value]) => ({
                label: FORM.EVENT_TYPES[key],
                value,
              }))}
              mode="multiple"
              placeholder={FORM.EVENTS}
              label={FORM.EVENTS}
              {...bindInputProps({
                name: "events",
                values,
                ...formProps,
              })}
              onChange={(value) => setFieldValue(`events`, value)}
            />
            <Button type="primary" size="full--width" onClick={handleSubmit}>
              {FORM.SUBMIT}
            </Button>
          </div>
        )}
      </Formik>
    </Drawer>
  );
};

export default Create;
